module.exports = __webpack_public_path__ + "img/center_front_upper_pocket_position.8ef90505.png";